var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticClass:"mt-2 mb-2",attrs:{"cols":"12","md":"12"}},[_c('PieChart',{attrs:{"title_header":'Solicitudes de compra ',"data":_vm.status_request}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }